import { render, staticRenderFns } from "./CadastroFluxoNovo.vue?vue&type=template&id=95b0834e&"
import script from "./CadastroFluxoNovo.vue?vue&type=script&lang=js&"
export * from "./CadastroFluxoNovo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFluxoNovo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports